import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tf-relation-display',
  standalone: true,
  template: `<span>{{ value() ?? '—' }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelationDisplayComponent {
  readonly value = input<unknown>();
}
